import { useEffect, useState } from "react"
import { globalLoadingCard } from "../../services/singletons/generic/globalLoadingCard";


export const useLoadingCard = () => {
    const [displayLoadingCard, setDisplayLoadingCard] = useState<string | undefined>(undefined);

    useEffect(() => {
        const unsubscribe = globalLoadingCard.subscribe(setDisplayLoadingCard);
        return unsubscribe;
    }, []);
    
    return {
        displayLoadingCard,
        setDisplayLoadingCard: globalLoadingCard.setDisplayLoadingCard.bind(globalLoadingCard)
    }
}